import React from "react";
// import Image7 from "../../../images/Image7.jpeg";
import SplitStorySection from "../../ui/SplitStorySection";
import volenteer from "../../../images/dance-kindness11.jpg"

const Introduction = () => (
  <SplitStorySection
    image={volenteer}
    imageAlt="Kindness engagements"
    className="bg-white"
  >
    <p>
      Kindness engagements are projects & events, both onsite & virtual, taken up by Kindness Unlimited.
    </p>
    <p>
      These engagements are mostly youth-centric that work in collaboration & with the support of kind individuals, corporations & high net worth individuals.
    </p>
    <p className="font-display text-xl font-semibold text-ku-royal">
      Connecting & unifying India by having people perpetually initiate acts of kindness.
    </p>
  </SplitStorySection>
);

export default Introduction;
